import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {deleteAttachmentMutation} from './__generated__/deleteAttachmentMutation.graphql';

const mutation = graphql`
	mutation deleteAttachmentMutation($input: DeleteAttachmentInput!) {
		deleteAttachment(input: $input) {
			clientMutationId
			deletedAttachmentId
		}
	}
`;

export interface DeleteAttachmentCommitInput {
	id: string;
}

function commit(
	environment: Environment,
	input: DeleteAttachmentCommitInput,
	onCompleted?: (r: deleteAttachmentMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<deleteAttachmentMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), id: input.id},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'deleteAttachmentMutation'};
